export default __webpack_public_path__ + "static/media/AbstractGradient.72b63d60.svg";